import deals from './Assects/deals2.png'
import fastFood from './Assects/fastFoods.webp'
import BBQGrilled from './Assects/BBQ&Grilled.jpg'
import Cuisines from './Assects/Cuisines.jpg'
import MealTyes from './Assects/MealTypes.jpg'
import Beverages from './Assects/Beverages.jpg'
import Desserts from './Assects/Desserts & Sweets.webp'


export const foodList = [
    {
        foodName: 'Special Offers & Deals',
        icon: deals
    },
    {
        foodName: 'Fast Foods',
        icon: fastFood
    },
    {
        foodName: 'BBQ & Grilled',
        icon: BBQGrilled
    },
    {
        foodName: 'Cuisines',
        icon: Cuisines
    },
    {
        foodName: 'Meal Types',
        icon: MealTyes
    },
    {
        foodName: 'Beverages',
        icon: Beverages
    },
    {
        foodName: 'Desserts & Sweets',
        icon: Desserts
    },
]